// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__EINg6","approved":"Status_approved__1iuQp","rejected":"Status_rejected__2B_Lq","expired":"Status_expired__1zYpL","label":"Status_label__1AS1_"};